import React, { ReactNode } from 'react';
import { PageGrid, BreadcrumbItem } from '../../shared';

interface PageHeaderWithActionsProps {
  title?: string;
  breadcrumbs: BreadcrumbItem[];
  actionButtons?: ReactNode;
  children: ReactNode;
}

export const PageHeaderWithActions = ({
  title,
  breadcrumbs,
  actionButtons,
  children,
}: PageHeaderWithActionsProps) => {
  return (
    <PageGrid 
      title={title} 
      breadcrumbs={breadcrumbs}
      actionButtons={actionButtons}
    >
      {children}
    </PageGrid>
  );
}; 